import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import Button from '../../UI/Buttons/Button';
import { APIGet } from '../../API/APIRequest';
import { useParams } from 'react-router-dom';

export function OrderCancellation(props) {
    const { t, i18n } = useTranslation();
    const { handleCancellation, handleRedirection, setEndDateParent, setOrderIdParent, formatDateParent} = props;
    const [endDate, setEndDate] = useState("");
    const [isUnpaidDD, setIsUnpaidDD] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const {fid} = useParams();

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" });
        const year = date.getFullYear();

        const suffix = (d) => {
            if (d > 3 && d < 21) return "th";
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

     const formattedDate = `${day}${suffix(day)} ${month} ${year}`;
     return formattedDate;
    }

    const getSubscriptionDetails =()=>{

        APIGet({
            "controller" : "order",
            "action" :"subcanceldetail",
            "identifier" : fid ,

        }).then((response)=>{
          
            const details = response?.data?.cancelSubscriptionDetail;
            const endDateString = details?.subscriptionEndDate;
            const endDate = formatDate(endDateString); 
            const endDateParent = formatDateParent(endDateString);
            setOrderIdParent(details?.orderId); //setting parent states values
            setEndDateParent(endDateParent);
            setEndDate(endDate);
            setIsUnpaidDD(response?.data?.isUnpaidDD);

        }).catch(()=>{

            console.log("Error in loading subscription details")
        })
    }

    useEffect(()=>{

        getSubscriptionDetails();

    }, [])

    return (<>
    
        <div className="container center-text"> 
            <div className="item-container">
                <h1 class="block-header" tabindex="-1">{t("cancellation.cancelsubscriptionquestion")} </h1>
            </div>
            <div className="item-container"> 
                <div class="label-text">
                    <label class="label" for="delivery-country">{t("cancellation.ifyoucanceltext")}   </label>
                    <p>{t("cancellation.futurepaymentswillstoptext")} </p>
                    <p>{t("cancellation.paymentwillbeprocessedtext")} </p>
                 </div>
            </div>
      
            <div className="item-container">
                <div class="border-seperator"></div>
            </div>
            <div className="item-container">
                {   !isUnpaidDD ?
                    <div class="item-wrapper">
                        <p class="small-text">{t("cancellation.willkeepsubscriptiontext")}</p>
                        <p class="large"><strong>{endDate}</strong> </p>
                    </div>
                    :
                    <div class="item-wrapper">
                    </div>
                }
            </div>
            <div className="item-container">
                <div class="item-wrapper center-flex-row">
                    {isLoading ? <Button type="button" buttonSize="medium" btnType="ghost" hasIcon="updating">{t("cancellation.cancelsubsbuttontext")} </Button> :   
                                 <Button type="button" buttonSize="medium" btnType="ghost" onClick={(e)=>{handleCancellation(e); setIsLoading(true)}}>{t("cancellation.cancelsubsbuttontext")} </Button>}

                   <Button type="button" buttonSize="medium" onClick={(e)=>{handleRedirection(e)}} >{t("cancellation.keepsubsbuttontext")} </Button>
                </div>    
            </div>
         </div>
     </>
    );
}